<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MgTTe8/tc-custom/9780300189193.jpg?1704288908010" alt="This image is the cover for the book Global Crisis"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Global Crisis
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The acclaimed historian demonstrates a link between climate change and social unrest across the globe during the mid-17th century.</b></p><p>Revolutions, droughts, famines, invasions, wars, regicides, government collapses—the calamities of the mid-seventeenth century were unprecedented in both frequency and severity. The effects of what historians call the "General Crisis" extended from England to Japan and from the Russian Empire to sub-Saharan Africa and the Americas.</p><p>In this meticulously researched volume, historian Geoffrey Parker presents the firsthand testimony of men and women who experienced the many political, economic, and social crises that occurred between 1618 to the late 1680s. He also incorporates the scientific evidence of climate change during this period into the narrative, offering a strikingly new understanding of the General Crisis.</p> Changes in weather patterns, especially longer winters and cooler and wetter summers, disrupted growing seasons and destroyed harvests. This in turn brought hunger, malnutrition, and disease; and as material conditions worsened, wars, rebellions, and revolutions rocked the world.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Geoffrey Parker
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Yale University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ed153e66